<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                        <h2 class="mb-0">Biography</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <button @click="setData()" type="button" class="btn btn-primary w-100 text-nowrap">Save</button>
                        </div>
                    </div>
                </div>

                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">

                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header py-2 d-flex justify-content-between align-items-center">
                                        <h5 class="mb-0">CV image</h5>
                                        <span v-if="cvImageUpdatedAt" class="small text-muted">Reemplazada local: {{ cvImageUpdatedAt }}</span>
                                    </div>
                                    <div class="card-body">
                                        <div class="row g-3 align-items-stretch">
                                            <div class="col-md-6 text-center">
                                                <img :src="cvPreviewSrc"
                                                     alt="CV image"
                                                     style="max-width:100%;max-height:320px;object-fit:contain;background:#f4f4f4;border-radius:6px" />
                                                <dl class="row small text-muted mt-3 mb-0 text-start">
                                                    <dt class="col-4">Path</dt>
                                                    <dd class="col-8 text-break">{{ cvLocalPath }}</dd>
                                                    <dt class="col-4">Dimensiones</dt>
                                                    <dd class="col-8">
                                                        <span v-if="cvWidth && cvHeight">{{ cvWidth }} × {{ cvHeight }} px</span>
                                                        <span v-else>—</span>
                                                    </dd>
                                                    <dt class="col-4">Tamaño</dt>
                                                    <dd class="col-8">{{ formatSize(cvSizeBytes) }}</dd>
                                                </dl>
                                            </div>
                                            <div class="col-md-6 d-flex">
                                                <div
                                                    class="dropzone p-4 text-center w-100 d-flex flex-column justify-content-center"
                                                    :class="{ 'dropzone--over': dragActive, 'dropzone--busy': uploadingCv }"
                                                    @click="!uploadingCv && $refs.cvInput.click()"
                                                    @dragover.prevent="dragActive = true"
                                                    @dragleave.prevent="dragActive = false"
                                                    @drop.prevent="onDropCv"
                                                    role="button"
                                                    tabindex="0"
                                                    @keydown.enter.prevent="!uploadingCv && $refs.cvInput.click()"
                                                >
                                                    <CloudUploadOutlineIcon :size="36" class="text-muted mb-2" />
                                                    <p v-if="!uploadingCv" class="mb-1"><strong>Arrastra una imagen aquí</strong> o haz click para reemplazar</p>
                                                    <p v-else class="mb-1"><strong>Subiendo…</strong></p>
                                                    <p class="text-muted small mb-0">JPG / PNG / WEBP · máx 5MB · se convierte a JPG automáticamente</p>
                                                    <input
                                                        ref="cvInput"
                                                        type="file"
                                                        class="d-none"
                                                        accept="image/jpeg,image/jpg,image/png,image/webp"
                                                        @change="onPickCv"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" v-model="artist.title_es" placeholder="Title Spanish" />
                                    <label>Title Spanish</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" v-model="artist.title_en" placeholder="Title English" />
                                    <label>Title English</label>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" v-model="artist.subtitle_es" placeholder="Subtitle Spanish" />
                                    <label>Subtitle Spanish</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" v-model="artist.subtitle_en" placeholder="Subtitle English" />
                                    <label>Subtitle English</label>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="artist.bio_es" placeholder="Biography Spanish" style="height:200px"></textarea>
                                    <label>Bio Spanish</label>
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="artist.bio_en" placeholder="Biography English" style="height:200px"></textarea>
                                    <label>Bio English</label>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'
import CloudUploadOutlineIcon from 'vue-material-design-icons/CloudUploadOutline.vue'

const ALLOWED = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp']
const MAX_BYTES = 5_000_000

export default {
    name: 'BiographyAdminComponent',
    components: { SideBar, TopBar, CloudUploadOutlineIcon },
    data() {
        return {
            artist: {},
            // The public /cv page reads from this fixed URL.
            cvPublicUrl: 'https://api.marinasamont.com/uploads/featured/marina-samont.jpg',
            cvLocalPath: 'uploads/featured/marina-samont.jpg',
            cvUploadedLocally: false,
            cvImageUpdatedAt: null,
            cvCacheBust: Date.now(),
            cvWidth: null,
            cvHeight: null,
            cvSizeBytes: null,
            dragActive: false,
            uploadingCv: false
        }
    },
    computed: {
        cvPreviewSrc() {
            // After a local upload, show the local file. Otherwise show what's live on marinasamont.com.
            if (this.cvUploadedLocally) {
                return this.$url + '/' + this.cvLocalPath + '?v=' + this.cvCacheBust
            }
            return this.cvPublicUrl + '?v=' + this.cvCacheBust
        }
    },
    created() {
        this.getData()
        this.loadCvInfo()
    },
    methods: {
        // Backend wraps these text fields with nl2br on GET; strip for editing.
        stripBr(s) {
            return (s || '').replace(/<br\s*\/?>/gi, '')
        },
        formatSize(n) {
            if (n === null || n === undefined) return '—'
            const v = Number(n)
            if (!isFinite(v) || v <= 0) return '—'
            if (v < 1024) return v + ' B'
            if (v < 1024 * 1024) return (v / 1024).toFixed(1) + ' KB'
            return (v / (1024 * 1024)).toFixed(2) + ' MB'
        },
        loadCvInfo() {
            axios.get(this.$url + '/cv-image', {
                headers: { 'Authorization': this.$store.state.token }
            }).then((res) => {
                this.cvLocalPath = res.data.path || this.cvLocalPath
                this.cvImageUpdatedAt = res.data.updated_at
                this.cvWidth = res.data.width
                this.cvHeight = res.data.height
                this.cvSizeBytes = res.data.size_bytes
            }).catch(() => { /* keep defaults */ })
        },
        getData() {
            axios.get(this.$url + '/artist', {
                headers: { 'Authorization': this.$store.state.token }
            }).then((res) => {
                const a = res.data || {}
                a.bio_es = this.stripBr(a.bio_es)
                a.bio_en = this.stripBr(a.bio_en)
                a.statement_es = this.stripBr(a.statement_es)
                a.statement_en = this.stripBr(a.statement_en)
                this.artist = a
            })
        },
        setData() {
            // Text fields only — the CV image has its own upload endpoint.
            axios.post(this.$url + '/artist', this.artist, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.$store.state.token
                }
            }).then(() => {
                this.$notify({ group: 'iasc', title: 'Saved', text: 'Biography updated', type: 'success' })
            }).catch(() => {
                this.$notify({ group: 'iasc', title: 'Error', text: 'Could not save', type: 'danger' })
            })
        },
        onPickCv(event) {
            const file = (event.target.files || [])[0]
            event.target.value = ''
            if (file) this.uploadCv(file)
        },
        onDropCv(event) {
            this.dragActive = false
            const file = (event.dataTransfer?.files || [])[0]
            if (file) this.uploadCv(file)
        },
        async uploadCv(file) {
            if (this.uploadingCv) return
            if (!ALLOWED.includes(file.type)) {
                this.$notify({ group: 'iasc', title: 'Archivo rechazado', text: 'Tipo no permitido', type: 'danger' })
                return
            }
            if (file.size > MAX_BYTES) {
                this.$notify({ group: 'iasc', title: 'Archivo rechazado', text: 'Supera 5MB', type: 'danger' })
                return
            }
            this.uploadingCv = true
            try {
                const fm = new FormData()
                fm.append('foto', file)
                const res = await axios.post(this.$url + '/cv-image', fm, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': this.$store.state.token
                    }
                })
                this.cvLocalPath = res.data.path
                this.cvImageUpdatedAt = res.data.updated_at
                this.cvWidth = res.data.width
                this.cvHeight = res.data.height
                this.cvSizeBytes = res.data.size_bytes
                this.cvUploadedLocally = true
                this.cvCacheBust = Date.now()
                this.$notify({ group: 'iasc', title: 'Listo', text: 'CV image actualizada', type: 'success' })
            } catch (err) {
                const msg = err?.response?.data?.error || 'No se pudo subir la imagen'
                this.$notify({ group: 'iasc', title: 'Error', text: msg, type: 'danger' })
            } finally {
                this.uploadingCv = false
            }
        }
    }
}
</script>

<style scoped>
.dropzone {
    border: 2px dashed #c8c8c8;
    border-radius: 12px;
    background: #fafafa;
    transition: background-color .15s ease, border-color .15s ease;
    cursor: pointer;
}
.dropzone:hover,
.dropzone:focus-visible {
    border-color: #6c757d;
    background: #f1f1f1;
    outline: none;
}
.dropzone--over {
    border-color: #0d6efd;
    background: #e7f1ff;
}
.dropzone--busy {
    cursor: progress;
    opacity: 0.8;
}
</style>
